import React from "react";
import {cn} from "./cn";

export const Loader: React.FC<{ className?: string }> = ({className}) => (
    <div className={cn("w-full flex items-center justify-center py-16", className)}>
        <div className="loader">
            <div></div>
            <div></div>
        </div>
    </div>
);
